<template>
  <el-dialog
    :visible.sync="checkSchoolSelectDelete"
    width="1180px"
    custom-class="modern-dialog"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    :show-close="false"
    top="4vh"
    @open="handleOpen"
  >
    <!-- 1. Themed Header (Deep Blue Gradient) -->
    <div class="dialog-header-themed">
      <div class="themed-left">
        <div class="themed-icon danger-icon"><i class="el-icon-delete"></i></div>
        <div class="themed-text">
          <div class="title-row">
            <h3>CHỌN TRƯỜNG XÓA ALBUM TRÊN SERVER VÀ S3 AMAZON</h3>
            <span class="status-badge" :class="isDeleteAlbum === 'Hoạt động' ? 'online' : 'offline'">
              <span class="dot"></span> {{ isDeleteAlbum }}
            </span>
          </div>
          <p>Khoảng thời gian áp dụng: <strong>{{ dateStart || '—' }}</strong> đến <strong>{{ dateEnd || '—' }}</strong></p>
        </div>
      </div>
      <div class="themed-close" @click="closeDialogByButton">
        <i class="el-icon-close"></i>
      </div>
    </div>

    <!-- 2. Content Area -->
    <div class="modern-dialog-content">
      <!-- Section: Search Filters -->
      <div class="form-section">
        <h4 class="section-divider"><i class="el-icon-search"></i> BỘ LỌC TÌM KIẾM TRƯỜNG</h4>
        <div class="filter-row">
          <el-select
            v-model="dataSearch.active"
            size="small"
            placeholder="Trạng thái kích hoạt"
            clearable
            style="width: 180px"
            @change="handleChangeActive"
          >
            <el-option
              v-for="item in statusAccountList"
              :key="item.key"
              :value="item.key"
              :label="item.value"
            />
          </el-select>

          <el-select
            v-model="dataSearch.deleteStatus"
            size="small"
            placeholder="Trạng thái xóa"
            clearable
            style="width: 170px"
            @change="searchHeaderMethod"
          >
            <el-option
              v-for="item in deleteList"
              :key="item.key"
              :value="item.key"
              :label="item.value"
            />
          </el-select>

          <el-input
            v-model="dataSearch.nameSchool"
            size="small"
            placeholder="Nhập tên trường học..."
            clearable
            style="width: 280px"
            @clear="searchHeaderMethod"
            @keyup.enter.native="searchHeaderMethod"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="searchHeaderMethod"
            />
          </el-input>
        </div>
      </div>

      <!-- Section: School Transfer List -->
      <div class="form-section">
        <h4 class="section-divider"><i class="el-icon-files"></i> DANH SÁCH TRƯỜNG CẦN XÓA ALBUM</h4>
        <div class="transfer-wrapper" v-loading="loadingDataDelete" element-loading-text="Đang tải danh sách trường...">
          <el-transfer
            v-model="dataTarget"
            filterable
            filter-placeholder="Tìm trường trong danh sách..."
            :titles="[
              `Tất cả trường (${dataSource.length})`,
              `Trường được xóa (${dataTarget.length})`
            ]"
            :button-texts="['Bỏ chọn', 'Chọn xóa']"
            :data="dataSource"
          >
            <span slot-scope="{ option }">{{ option.label }}</span>
          </el-transfer>
        </div>

        <div class="note-danger-card mt-3">
          <span class="note-text">
            <i class="el-icon-warning"></i>
            <strong>Cảnh báo quan trọng:</strong> Thao tác này sẽ xóa vĩnh viễn toàn bộ album ảnh trong khoảng thời gian đã chọn của các trường được chọn trên cả máy chủ và S3. Dữ liệu đã xóa <strong>không thể phục hồi</strong>.
          </span>
        </div>
      </div>
    </div>

    <!-- 3. Themed Footer -->
    <div class="dialog-footer-themed">
      <el-button size="medium" @click="closeDialogByButton">
        <i class="el-icon-close"></i> Đóng
      </el-button>
      <el-button
        size="medium"
        class="gradient-btn red-btn"
        icon="el-icon-delete"
        :disabled="isDeleteAlbum === 'Ngừng hoạt động' || dataTarget.length === 0"
        :loading="loadingButton"
        @click="deleteAlbumDataServerAndS3"
      >
        Tiến hành xóa album ({{ dataTarget.length }} trường)
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import ManageDataService from "@/services/AdminService/ManageDataService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

export default {
  name: "DeletePictureServerAndS3Dialog",
  props: {
    checkSchoolSelectDelete: {
      type: Boolean,
      default: false,
    },
    isDeleteAlbum: {
      type: String,
      default: "Ngừng hoạt động",
    },
    dateStart: {
      type: String,
      default: "",
    },
    dateEnd: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      statusAccountList: [
        { key: true, value: "Đã kích hoạt" },
        { key: false, value: "Chưa kích hoạt" },
      ],
      deleteList: [],
      deleteListActive: [{ key: false, value: "Đã xóa" }],
      deleteListNoActive: [
        { key: true, value: "Chưa xóa" },
        { key: false, value: "Đã xóa" },
      ],
      dataSearch: {
        deleteStatus: false,
        active: true,
        nameSchool: "",
      },
      listSchool: [],
      loadingDataDelete: false,
      dataSource: [],
      dataTarget: [],
      loadingButton: false,
      showMessageRunAction: false,
    };
  },
  watch: {
    listSchool: {
      handler() {
        if (this.listSchool.length > 0) {
          setTimeout(() => {
            this.loadingDataDelete = false;
          }, 400);
        }
      },
    },
  },
  methods: {
    handleChangeActive() {
      if (this.dataSearch.active === true) {
        this.deleteList = this.deleteListActive;
      } else {
        this.deleteList = this.deleteListNoActive;
      }
      this.searchHeaderMethod();
    },
    async searchHeaderMethod() {
      this.loadingDataDelete = true;
      this.dataTarget = [];
      try {
        const res = await ManageDataService.searchSchoolTransfer(
          this.dataSearch.deleteStatus,
          this.dataSearch.active,
          this.dataSearch.nameSchool
        );
        this.listSchool = res.data.data.schoolList || [];
      } catch (err) {
        console.error(err);
      } finally {
        this.setDataSource();
        this.loadingDataDelete = false;
      }
    },
    handleOpen() {
      this.loadingDataDelete = false;
      this.deleteList = this.deleteListActive;
      this.searchHeaderMethod();
    },
    closeDialog() {
      this.$emit("close");
      this.resetFormData();
      this.handleClear();
    },
    closeDialogByButton() {
      this.$emit("close");
      this.resetFormData();
      this.handleClear();
    },
    handleClear() {
      this.dataSearch.nameSchool = "";
      this.dataSearch.active = true;
      this.dataSearch.deleteStatus = false;
    },
    resetFormData() {
      setTimeout(() => {
        this.dataSource = [];
        this.dataTarget = [];
        this.deleteList = [];
      }, 300);
    },
    deleteAlbumDataServerAndS3() {
      this.$confirm(
        `Bạn có chắc chắn muốn xóa album của ${this.dataTarget.length} trường đã chọn? Thao tác này không thể hoàn tác!`,
        "Cảnh báo xóa dữ liệu",
        {
          confirmButtonText: "Xác nhận xóa",
          cancelButtonText: "Hủy bỏ",
          type: "warning",
        }
      ).then(() => {
        this.$emit("childEvent", true);
        this.$emit("close");
        ManageDataService.deleteAlbumDataServerAndS3(
          this.dateStart,
          this.dateEnd,
          this.dataTarget
        )
          .then(() => {
            NotifyMessage.leftCornerNotificationSuccess("Đã bắt đầu tiến trình xóa album!");
          })
          .catch((err) => {
            NotifyMessage.leftCornerNotificationError("Có lỗi xảy ra, không thể thực hiện thao tác!");
            console.error(err);
          })
          .finally(() => {
            this.loadingButton = false;
            this.closeDialog();
          });
      });
    },
    setDataSource() {
      const dataResponse = [];
      this.listSchool.forEach((school) => {
        dataResponse.push({
          label: `${school.id} - ${school.schoolName}`,
          key: school.id,
        });
      });
      this.dataSource = dataResponse;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .modern-dialog {
  border-radius: 14px !important;
  overflow: hidden;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);

  .el-dialog__header {
    display: none !important;
  }

  .el-dialog__body {
    padding: 0 !important;
  }
}

.dialog-header-themed {
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  padding: 18px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #ffffff;
  position: relative;

  .themed-left {
    display: flex;
    align-items: center;
    gap: 16px;

    .themed-icon {
      width: 44px;
      height: 44px;
      border-radius: 10px;
      background: rgba(255, 255, 255, 0.15);
      backdrop-filter: blur(8px);
      border: 1px solid rgba(255, 255, 255, 0.25);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 22px;
      color: #ffffff;

      &.danger-icon {
        background: rgba(239, 68, 68, 0.25);
        border-color: rgba(239, 68, 68, 0.4);
        color: #fca5a5;
      }
    }

    .themed-text {
      .title-row {
        display: flex;
        align-items: center;
        gap: 10px;

        h3 {
          margin: 0;
          font-size: 17px;
          font-weight: 700;
          letter-spacing: 0.5px;
          color: #ffffff;
        }
      }

      p {
        margin: 4px 0 0 0;
        font-size: 13px;
        color: rgba(255, 255, 255, 0.85);

        strong {
          color: #ffffff;
        }
      }
    }
  }

  .themed-close {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.1);
    color: #ffffff;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background: rgba(255, 255, 255, 0.25);
      transform: scale(1.05);
    }
  }
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 9999px;

  .dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
  }

  &.online {
    background-color: rgba(34, 197, 94, 0.2);
    color: #4ade80;
    .dot {
      background-color: #22c55e;
      box-shadow: 0 0 8px #22c55e;
    }
  }

  &.offline {
    background-color: rgba(239, 68, 68, 0.2);
    color: #fca5a5;
    .dot {
      background-color: #ef4444;
    }
  }
}

.modern-dialog-content {
  padding: 20px 24px;
  max-height: 68vh;
  overflow-y: auto;
}

.form-section {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 14px 16px;
  margin-bottom: 16px;

  .section-divider {
    margin: 0 0 12px 0;
    font-size: 12.5px;
    font-weight: 700;
    color: #2563eb;
    display: flex;
    align-items: center;
    gap: 6px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 1px solid #e2e8f0;
    padding-bottom: 6px;
  }
}

.filter-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.transfer-wrapper {
  display: flex;
  justify-content: center;

  /deep/ .el-transfer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .el-transfer-panel {
      width: 44%;
      border-radius: 8px;
      border: 1px solid #cbd5e1;

      .el-transfer-panel__header {
        background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
        color: #ffffff;
        border-top-left-radius: 7px;
        border-top-right-radius: 7px;

        .el-checkbox .el-checkbox__label {
          color: #ffffff;
          font-weight: 600;
          font-size: 13.5px;
        }
      }

      .el-transfer-panel__body {
        height: 320px;
      }

      .el-transfer-panel__filter {
        margin: 8px 10px;
        width: calc(100% - 20px);
      }

      .el-transfer-panel__list.is-filterable {
        height: 255px;
      }
    }

    .el-transfer__buttons {
      padding: 0 12px;
      display: flex;
      flex-direction: column;
      gap: 10px;

      .el-button {
        margin: 0;
        border-radius: 6px;
      }
    }
  }
}

.note-danger-card {
  background: #fef2f2;
  border: 1px solid #fecaca;
  padding: 10px 14px;
  border-radius: 6px;

  .note-text {
    font-size: 12.5px;
    color: #b91c1c;
    line-height: 1.5;

    i {
      margin-right: 4px;
      font-size: 14px;
    }
  }
}

.dialog-footer-themed {
  padding: 14px 24px;
  background: #f1f5f9;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  border-bottom-left-radius: 14px;
  border-bottom-right-radius: 14px;
}

.gradient-btn {
  border: none !important;
  color: #ffffff !important;
  font-weight: 600 !important;
  border-radius: 6px !important;
  transition: all 0.3s ease !important;

  &.red-btn {
    background: linear-gradient(90deg, #ef4444 0%, #dc2626 100%) !important;
    box-shadow: 0 4px 10px rgba(239, 68, 68, 0.3);
    &:hover {
      opacity: 0.9;
      transform: translateY(-1px);
    }
  }
}

.mt-3 {
  margin-top: 12px;
}
</style>
